import { useEffect } from "react";

/**
 * Adds "in-view" to elements with class "reveal-on" so they fade up
 * when scrolled into the viewport. Runs once per element.
 */
export function useReveal() {
  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll(".reveal-on"));
    if (nodes.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);
}